module.exports = __webpack_public_path__ + "static/media/synapseLogo.0a1ad81c.svg";